import Http from './api'

// 登入
export function login (payload) {
  return Http.post('/auth/login', payload, { silenceErrorMsg: true })
}

// 取得使用者資訊
export function getUser (payload) {
  return Http.get('/user', payload)
}

export default {
  login,
  getUser
}
